import { MediaQuery } from '@/@bothrs-ui/web/components/media-query/MediaQuery'
import { breakpoints } from '@/config/layout'
import { StHeaderContainer } from './ContentPageLayout.styled'

import type { ReactNode } from 'react'

type Props = {
  header?: ReactNode
  showHeaderAlways?: boolean
}

const ContentPageLayoutHeader = ({ header, showHeaderAlways }: Props) => {
  // Wrapping the header for styling
  const headerWrapped = <StHeaderContainer>{header}</StHeaderContainer>

  // Usually we will only render the header when only one Page can be shown
  // But the `showHeaderAlways` flag allows you to override this behavior
  return showHeaderAlways ? headerWrapped : <MediaQuery query={breakpoints.toM}>{headerWrapped}</MediaQuery>
}

export { ContentPageLayoutHeader }
